import { createFileRoute } from "@tanstack/react-router";

import { InvitationAcceptancePage } from "../pages/invitation-page";

export const Route = createFileRoute("/accept-invitation")({
  component: InvitationAcceptancePage,
});
